export const LanguageMenuPTBRTranslations = {
  languageMenuSelectButtonLabel: 'Botão para selecionar a linguagem',
  languageMenuPortugueseButtonLabel: 'Botão para selecionar português',
  languageMenuEnglishButtonLabel: 'Botão para selecionar inglês',
  languageMenuSelectedFlagImageAlt: 'Bandeira da linguagem selecionada',
  languageMenuBrasilFlagImageAlt: 'Bandeira do Brasil (português)',
  languageMenuUSAFlagImageAlt:
    'Bandeira dos Estados Unidos da América (inglês)',
};
